import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar.js";
import ClientData from "./Pages/ClientData.js";
import UploadExcel from "./Pages/UploadExcel.js";
import Labels from "./Pages/Labels.js";
import LabelsTable from "./Pages/LabelsTable.js";

function App() {
  return (
    <Router>
      <Navbar /> 
      <div style={{ padding: "20px" }}>
        <Routes>
          <Route path="/" element={<ClientData />} />
          <Route path="/uploadexcel" element={<UploadExcel />} />
          <Route path="/labels" element={<Labels />} />
          <Route path="/labelslist" element={<LabelsTable/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
